import { render, staticRenderFns } from "./AssetsCreate.vue?vue&type=template&id=40aff500&"
import script from "./AssetsCreate.vue?vue&type=script&lang=js&"
export * from "./AssetsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports